// extracted by mini-css-extract-plugin
module.exports = {"pageHeader":"TagsList_pageHeader__3z_gb"};